// extracted by mini-css-extract-plugin
export default {"main_section":"MarketPlaceDesktopTop_main_section__RGYh9","container":"MarketPlaceDesktopTop_container__I0eqr","title_break":"MarketPlaceDesktopTop_title_break__Es6Yp"};